var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAutoApprove = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "AutoApprove",
  fill: "#41505F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.6316488,10.3979787 L12.9833879,10.3979787 C12.6620385,10.3979787 12.4005483,10.1364885 12.4005483,9.81513908 L12.4005483,4.58218453 C12.4005483,4.01509734 11.6759369,3.78511198 11.345136,4.2450827 L6.10903099,12.6789294 C5.83493885,13.0632885 6.10903099,13.5988708 6.58160365,13.5988708 L10.2204131,13.5988708 C10.5417625,13.5988708 10.8032527,13.860361 10.8032527,14.1817104 L10.8032527,19.4178155 C10.8032527,19.9849027 11.5278641,20.214888 11.858665,19.7549173 L17.107372,11.3179201 C17.3783136,10.933561 17.1042215,10.3979787 16.6316488,10.3979787 Z",
  id: "Auto-Approve"
})))));
export { SvgAutoApprove as ReactComponent };
export default __webpack_public_path__ + "static/media/autoApprove.a1636f2d.svg";